/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Tableheaders_Title1Inputs */

const id_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul`)
};

const ms_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tajuk`)
};

const da_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const de_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const en_us2_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const es_es2_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

const es_mx2_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

const fil_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamagat`)
};

const fr_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre`)
};

const it_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo`)
};

const hu_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cím`)
};

const nl_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const no_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tittel`)
};

const pl_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tytuł`)
};

const pt_br2_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

const pt_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

const ro_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titlu`)
};

const fi_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otsikko`)
};

const sv_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel`)
};

const vi_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề`)
};

const tr_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlık`)
};

const cs_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název`)
};

const bg_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заглавие`)
};

const ru_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название`)
};

const uk_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назва`)
};

const ar_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العنوان`)
};

const hi_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षक`)
};

const th_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อ`)
};

const ja_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトル`)
};

const zh_cn2_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题`)
};

const zh_hant1_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標題`)
};

const ko_home_tableheaders_title1 = /** @type {(inputs: Home_Tableheaders_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제목`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Home_Tableheaders_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_tableheaders_title1 = /** @type {((inputs?: Home_Tableheaders_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Tableheaders_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_tableheaders_title1(inputs)
	if (locale === "ms") return ms_home_tableheaders_title1(inputs)
	if (locale === "da") return da_home_tableheaders_title1(inputs)
	if (locale === "de") return de_home_tableheaders_title1(inputs)
	if (locale === "en-US") return en_us2_home_tableheaders_title1(inputs)
	if (locale === "es-ES") return es_es2_home_tableheaders_title1(inputs)
	if (locale === "es-MX") return es_mx2_home_tableheaders_title1(inputs)
	if (locale === "fil") return fil_home_tableheaders_title1(inputs)
	if (locale === "fr") return fr_home_tableheaders_title1(inputs)
	if (locale === "it") return it_home_tableheaders_title1(inputs)
	if (locale === "hu") return hu_home_tableheaders_title1(inputs)
	if (locale === "nl") return nl_home_tableheaders_title1(inputs)
	if (locale === "no") return no_home_tableheaders_title1(inputs)
	if (locale === "pl") return pl_home_tableheaders_title1(inputs)
	if (locale === "pt-BR") return pt_br2_home_tableheaders_title1(inputs)
	if (locale === "pt") return pt_home_tableheaders_title1(inputs)
	if (locale === "ro") return ro_home_tableheaders_title1(inputs)
	if (locale === "fi") return fi_home_tableheaders_title1(inputs)
	if (locale === "sv") return sv_home_tableheaders_title1(inputs)
	if (locale === "vi") return vi_home_tableheaders_title1(inputs)
	if (locale === "tr") return tr_home_tableheaders_title1(inputs)
	if (locale === "cs") return cs_home_tableheaders_title1(inputs)
	if (locale === "bg") return bg_home_tableheaders_title1(inputs)
	if (locale === "ru") return ru_home_tableheaders_title1(inputs)
	if (locale === "uk") return uk_home_tableheaders_title1(inputs)
	if (locale === "ar") return ar_home_tableheaders_title1(inputs)
	if (locale === "hi") return hi_home_tableheaders_title1(inputs)
	if (locale === "th") return th_home_tableheaders_title1(inputs)
	if (locale === "ja") return ja_home_tableheaders_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_tableheaders_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_tableheaders_title1(inputs)
	return ko_home_tableheaders_title1(inputs)
});
export { home_tableheaders_title1 as "home.tableHeaders.title" }